import { styled } from '@mui/material';

export const StyledFlexContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gridGap: '0.5rem',
  justifyContent: 'flex-start',
}));

export const StyledAppNumberInputWrapper = styled('div')<{
  isInputChanged?: boolean;
}>(({ isInputChanged }) => ({
  ...(isInputChanged && {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#88B8FF',
    },
  }),
}));
